import React from 'react';

const KitcoLogo = ({ className = "h-8" }) => {
  return (
    <img 
      src="https://customer-assets.emergentagent.com/job_coinrec-tracker/artifacts/w73rvxh2_2.Kitco%20New%20Logo_dark%20backgrounds_transp.png"
      alt="Kitco Logo"
      className={className}
    />
  );
};

export default KitcoLogo;